import { render } from "./InboxView.vue?vue&type=template&id=2711a65c&ts=true"
import script from "./InboxView.vue?vue&type=script&lang=ts"
export * from "./InboxView.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__